/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Command_Searchemoji1Inputs */

const he_command_searchemoji1 = /** @type {(inputs: Command_Searchemoji1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חפש אימוג'י`)
};

const en_command_searchemoji1 = /** @type {(inputs: Command_Searchemoji1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Emoji`)
};

/**
* | output |
* | --- |
* | "Search Emoji" |
*
* @param {Command_Searchemoji1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const command_searchemoji1 = /** @type {((inputs?: Command_Searchemoji1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Command_Searchemoji1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_command_searchemoji1(inputs)
	return en_command_searchemoji1(inputs)
});
export { command_searchemoji1 as "command_searchEmoji" }